import React from 'react'
import { useLocation } from 'react-router-dom'
import Tabs from '../../../components/Tabs'
import SelectList from '../../../components/SelectMenuList'
import { useGeoState } from '../../../components/GeoProvider'
import Spinner from '../../../components/Loader/Spinner'
import { useNavigate } from 'react-router-dom/dist'
import Header from './Header'
import SystemNotification from '../../Dashboard/SystemNotification'
import DashboardMap from './DashboardMap'
import Filter from './../Filter'
import typeDisplayOptions from '../../Dashboard/typeDisplayOptions'
import PopulationScaling from '../PopulationScaling'
const ModelTabs = ({  geo_type,  geo_parent,  zoomLocation }) => {
  let getCategoryState=window.localStorage.getItem('bt_category')
  const tabIndices = React.useMemo(
    () => ['#prenatal', '#delivery'],
    []
  )
  const [selectedTab, setSelectedTab] = React.useState(getCategoryState-1)

  const history = useNavigate()
  const location = useLocation()

  const onLoadTabs = React.useCallback(() => {
    for (const key in tabIndices) {
      if (location.hash === tabIndices[key]) setSelectedTab(+key)
    }
  }, [location.hash, tabIndices])

  const tabsChangeHandler = (index) => {
    //setCategoryState(index+1)
    window.localStorage.setItem('bt_category',index+1)
    setSelectedTab(index)
    history({ hash: tabIndices[index] })
  }

  React.useEffect(() => {
    onLoadTabs()
  }, [onLoadTabs])

  return (
    <> <div style={{marginTop:'24px'}}>  <SelectList
    dropdownData={typeDisplayOptions}
    defaultValue={'birthtrend'}
    defaultLabel={'Births & Trends'}
  /></div>
    <Tabs selectedIndex={selectedTab} onChange={tabsChangeHandler} className={'birthtrend'}>
     
      <Tabs.Panel label="Prenatal">
        {tabIndices[selectedTab] === '#prenatal' ? (
              <>
              <Filter filter_type='prenatal' headerType='FIPS'/>
              <DashboardMap  geo_type={geo_type}
                geo_parent={geo_parent}
                zoomLocation={zoomLocation}/> </>
        ) : (
          <Spinner />
        )}
      </Tabs.Panel>
      <Tabs.Panel label="Delivery">
        {tabIndices[selectedTab] === '#delivery' ? (
        
        <>
          <Filter filter_type='delivery' headerType='FIPS'/>
          <DashboardMap  geo_type={geo_type}
                geo_parent={geo_parent}
                zoomLocation={zoomLocation} /> 
           <PopulationScaling geo_type={geo_type} geo_id={zoomLocation} searchLocationText=''/>
          </>
        ) : (
          <Spinner />
        )}
      </Tabs.Panel>
      
    </Tabs>
    </>
  )
}

export default ModelTabs
